<template>
  <b-modal
    ref="preGeracao"
    size="xl"
    hide-footer
    no-close-on-backdrop
    :dialog-class="'alteracao-tamanho-pre-geracao'"
    :modal-class="'center-modal'"
    title="Contrato comercial"
    title-class="titulo-modal"
    @show="showPreGeracao"
    @hide="limparCampos"
  >
    <b-tabs fill>
      <b-tab
        title="Pré-geração do contrato"
        active
      >
        <pre-geracao-contrato-proposta-tab
          ref="preGeracaoTab"
          :proposta-atual="propostaAtual"
          :status-proposta="statusProposta"
          @socios-carregados="handleSociosCarregados"
          @fechar-modal="fecharModal"
          @abrir-modal-status="abrirModalStatus"
        />
      </b-tab>
      <b-tab
        title="Contrato"
        :lazy="true"
        :disabled="!liberaTabContrato()"
      >
        <contrato-proposta-tab
          ref="contratoPropostaTab"
          :pre-contrato-gerado="liberaTabContrato()"
          :proposta-atual="valueInner"
          :pre-geracao-socios="preGeracaoSocios"
          @contrato-enviado="handleContratoEnviado"
        />
      </b-tab>
    </b-tabs>

    <alterar-status
      ref="alterarStatus"
      :proposta-atual="propostaAtual"
      :status-proposta="statusProposta"
      @close-modal="fecharModal"
      @alterar-status="onStatusAlterado"
    />
  </b-modal>
</template>

<style lang="scss">
.alteracao-tamanho-pre-geracao {
  width: 1000px !important;
}

.center-modal {
  display: flex !important;
  justify-content: center !important;
}

.titulo-modal {
  font-size: 19px;
}

.aviso-pre-geracao {
  text-align: left;
  font-size: 15.5px;
  background-color: rgb(231, 231, 231) !important;
  padding: 0.5rem;
  margin-bottom: 1rem;
  color: rgb(255, 0, 0);
  font-weight: bold;
  p {
    margin: 0;
  }
}

.aviso-amarelo {
  text-align: left;
  font-size: 15.5px;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 10px;
}
</style>

<script>
import AlterarStatus from '../alterar-status/AlterarStatus.vue'

export default {
  name: 'PreGeracaoContrato',
  components: {
    PreGeracaoContratoPropostaTab: () => import('./PreGeracaoContratoPropostaTab.vue'),
    ContratoPropostaTab: () => import('./ContratoPropostaTab.vue'),
    AlterarStatus,
  },
  props: {
    propostaAtual: {
      type: Object,
      default: () => ({}),
    },
    statusProposta: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      valueInner: {},
      socioEmEdicao: false,
      preGeracaoSocios: [],
    }
  },
  watch: {
    propostaAtual(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = { ...value }
        if (
          this.valueInner.id > 0
          && (
            this.valueInner.etiquetas?.some(e => e.descricao === 'Em análise')
            || this.valueInner.etiquetas?.some(e => e.descricao === 'Aguardando envio de dados')
          )
        ) {
          this.$refs.preGeracao.show()
        }
      }
    },
  },
  created() {
    // espelho interno da proposta, usado na aba de contrato
    this.valueInner = { ...(this.propostaAtual || {}) }
  },
  methods: {
    showPreGeracao() {
      this.$nextTick(() => {
        if (this.$refs.preGeracaoTab) {
          this.$refs.preGeracaoTab.showPreGeracao()
        }
      })
    },
    limparCampos() {
      if (this.$refs.preGeracaoTab && this.$refs.preGeracaoTab.limparCampos) {
        this.$refs.preGeracaoTab.limparCampos()
      }
    },
    handleSociosCarregados(socios) {
      this.preGeracaoSocios = socios
    },
    handleContratoEnviado(payload) {
      // ao enviar/atualizar o contrato, recarrega dados da aba contrato
      this.$isLoading(false)
      if (this.$refs.contratoPropostaTab) {
        this.$refs.contratoPropostaTab.loadDocumentosAssinatura()
      }
      this.$emit('contrato-enviado', payload)
    },
    fecharModal() {
      this.$refs.preGeracao.hide()
    },
    // AGORA não abre mais a modal: altera direto para "Em análise"
    abrirModalStatus() {
      if (this.$refs.alterarStatus && this.$refs.alterarStatus.alterarDiretoEmAnalise) {
        this.$refs.alterarStatus.alterarDiretoEmAnalise()
      } else if (this.$refs.alterarStatus && this.$refs.alterarStatus.$refs.modalAlterarStatus) {
        // fallback de segurança: se o método não existir, mantém o comportamento antigo
        this.$refs.alterarStatus.$refs.modalAlterarStatus.show()
      }
    },
    onStatusAlterado(cartaoProposta) {
      // Atualiza o espelho interno usado na aba Contrato
      if (cartaoProposta && typeof cartaoProposta === 'object') {
        this.valueInner = {
          ...(this.valueInner || {}),
          ...cartaoProposta,
        }

        // Atualiza os dados internos da aba de pré-geração
        if (this.$refs.preGeracaoTab) {
          this.$refs.preGeracaoTab.valueInner = {
            ...(this.$refs.preGeracaoTab.valueInner || {}),
            ...cartaoProposta,
          }

          // Recarrega os dados do pré-contrato (equivalente ao F5, mas só na modal)
          this.$refs.preGeracaoTab.showPreGeracao()
        }

        // Notifica o componente pai (BotoesAcoes) para atualizar o card da proposta
        this.$emit('atualiza-cartao-proposta', cartaoProposta)
      }
    },
    liberaTabContrato() {
      return this.preGeracaoSocios.length > 0
        && !this.$refs.preGeracaoTab.socioEmEdicao
        && this.preGeracaoSocios.some(socio => socio.responsavelRFB === true)
    },
  },
}
</script>
